import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute} from '@angular/router';
import InsuranceRouteResolverService from 'src/app/domain/service/route-resolver/insurance-route-resolver.service';
import {AppEnvironmentService} from 'src/app/infrastructure/environment/app-environment/app-environment.service';
import {Router} from 'src/app/infrastructure/router/router';
import StyleStore from 'src/app/infrastructure/store/style.store';
import {Button, Style} from 'src/app/infrastructure/style/style';
import {WebPage} from 'src/app/ui/webapp/page/web.page';

@Component({
  selector: 'app-insurance',
  templateUrl: 'insurance.page.html',
})

export class InsurancePage extends WebPage {

  constructor(
    router: Router,
    appEnvironment: AppEnvironmentService,
    titleService: Title,
    private readonly insuranceRouteResolver: InsuranceRouteResolverService,
    private activatedRoute: ActivatedRoute,
    private styleStore: StyleStore,
  ) {
    super(router, appEnvironment, titleService);
  }

  public goToAdvantagesUrl(): void {
    this.navigateToRelative(this.insuranceRouteResolver.resolveAdvantagesUrl(), this.activatedRoute);
  }

  public getInsuranceFaqUrl(): void {
    this.navigateToRelative(this.insuranceRouteResolver.resolveInsuranceFaqUrl(), this.activatedRoute);
  }

  protected onInit() {
    const style = {
      buttons: ['back' as Button]
    } as Style;
    this.styleStore.save(style);
  }
}
